import { render, staticRenderFns } from "./CostTypesModal.vue?vue&type=template&id=dc046af4&scoped=true&"
import script from "./CostTypesModal.vue?vue&type=script&lang=js&"
export * from "./CostTypesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc046af4",
  null
  
)

export default component.exports